module.exports = __webpack_public_path__ + "static/media/login-rigips.308cd348.jpg";